import styled from "styled-components";
import { PC_HEADER_HEIGHT, SP_BREAKPOINT } from "../../constants/app";
import { Button, ButtonVariant } from "../atoms/Button";
import { IconComponent } from "../atoms/icons/types";

type Props = {
  title: string;
  number?: string;
  button?: {
    text: string;
    variant: ButtonVariant;
    onClick?: () => void;
    icon?: IconComponent;
  };
  children: React.ReactNode;
  useFitHeight?: boolean;
  useStickyTitle?: boolean;
};

export const MainTemplate: React.FC<Props> = ({
  title,
  number,
  button,
  children,
  useFitHeight,
  useStickyTitle,
}) => {
  return (
    <StyledMainTemplateContainer $useFitHeight={useFitHeight}>
      <StyledHeaderContainer $useStickyTitle={useStickyTitle}>
        <StyleTitleContainer>
          <StyledTitle>{title}</StyledTitle>
          {number && <StyledNumber>{number}</StyledNumber>}
        </StyleTitleContainer>
        {button && <Button {...button} />}
      </StyledHeaderContainer>

      <StyledChildrenContainer
        $useFitHeight={useFitHeight}
        $useStickyTitle={useStickyTitle}
      >
        {children}
      </StyledChildrenContainer>
    </StyledMainTemplateContainer>
  );
};

const StyledMainTemplateContainer = styled.div<{ $useFitHeight?: boolean }>`
  @media (max-width: ${SP_BREAKPOINT}) {
    ${({ $useFitHeight }) =>
      $useFitHeight ? `display: flex; flex-direction: column;` : ""};
  }

  width: 100%;
  height: 100%;
`;

const StyledHeaderContainer = styled.div<{ $useStickyTitle?: boolean }>`
  @media (max-width: ${SP_BREAKPOINT}) {
    height: fit-content;
    flex-direction: column;
    gap: 20px;
    padding: 16px;
    align-items: flex-start;

    button {
      width: 100%;
    }
  }

  height: ${PC_HEADER_HEIGHT};
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 40px;

  ${({ $useStickyTitle }) =>
    $useStickyTitle
      ? `
    position: sticky;
    top: 0;
    background: white;
    z-index: 1000;
    `
      : ""}
`;

const StyleTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
const StyledTitle = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    font-size: 16px;
  }

  font-size: 24px;
  font-weight: 700;
  line-height: 100%;
`;

const StyledNumber = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    font-size: 13px;
  }
  font-size: 20px;
`;

const StyledChildrenContainer = styled.div<{
  $useFitHeight?: boolean;
  $useStickyTitle?: boolean;
}>`
  @media (max-width: ${SP_BREAKPOINT}) {
    padding: 0 16px;
    ${({ $useFitHeight }) => ($useFitHeight ? `flex: 1; height: auto;` : "")};
    ${({ $useStickyTitle }) => ($useStickyTitle ? `height: 100%;` : "")};
  }
  display: flex;
  flex-direction: column;
  height: auto;

  display: flex;
  flex-direction: column;
  height: auto;
  padding: 0 40px;
  ${({ $useFitHeight }) =>
    $useFitHeight ? `height: calc(100% - ${PC_HEADER_HEIGHT})` : ""};

  ${({ $useStickyTitle }) =>
    $useStickyTitle
      ? `
    overflow-y: auto;
    height: calc(100% - ${PC_HEADER_HEIGHT});
    `
      : ""}
`;
